import config from '@/common/config';
import { useEffect, useMemo } from 'react';
import { formatUnits } from 'viem/utils';
import { useBalance } from 'wagmi';
import useWindowFocus from '@/hooks/useWindowFocus';

const useWalletBalance = (walletAddress: `0x${string}` | undefined, tokenAddress: `0x${string}`) => {
  const { data, isLoading, isError, refetch } = useBalance({
    address: walletAddress,
    token: tokenAddress,
    chainId: config.chain?.id,
  });

  const isFocused = useWindowFocus();

  useEffect(() => {
    if (isFocused) {
      refetch();
    }
  }, [isFocused, refetch]);

  const displayBalance = useMemo(() => {
    if (!data) return '0.00';
    const numberString = formatUnits(data.value, data.decimals);
    const [integerPart, decimalPart] = numberString.split('.');
    let truncated;
    if (decimalPart) {
      truncated = `${integerPart}.${decimalPart.slice(0, 2)}`;
    } else {
      truncated = integerPart;
    }
    return truncated;
  }, [data]);

  return { data: { ...data, displayBalance }, isLoading, isError };
};

export default useWalletBalance;
